export default "__VITE_ASSET__Dg7E7BoI__"